<div
  class="mx-2 mb-2 p-1 border rounded border-solid border-gray-300 dark:border-gray-500 uppercase font-semibold text-base text-center text-gray-500 dark:text-gray-200">
  <form [formGroup]="formSaveConvenio">

    <div class="flex flex-col">
      <div class="flex justify-between items-center">
        <div class="estilo-dark dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
          <label for="#id_tranportista"
            class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent">Transportista </label>
          <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700"
            formControlName="id_scct_transportista">
            <option value="" selected disabled>Seleccionar transportista</option>
            <option *ngFor="let trasn of dataTransportistas" value="{{trasn.id}}">
              {{trasn.transportista}}</option>
          </select>
        </div>
        <div class="estilo-dark dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
          <button (click)="saveTransportistaModal = true"
            class="flex items-center mt-6 p-2 bg-gray-50 text-xs uppercase dark:bg-transparent rounded text-gray-500 dark:text-gray-50 font-semibold border-2 border-gray-300 hover:border-blue-600">

            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
            </svg>

            <span class="ml-2">
              Agregar Transportista
            </span>

          </button>
        </div>

      </div>
      <hr class="mb-2 dark:border-gray-500">

      <div class="flex dark:text-gray-100 dark:bg-transparent">

        <div class="estilo-dark dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
          <label for="#convenio" class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent">Fecha inicio</label>
          <input formControlName="fecha_inicio" autocomplete="off" required
            class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
            type="date" />
        </div>
        <div class=" estilo-dark dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
          <div class="w-full text-center estilo-dark dark:text-gray-100 dark:bg-transparent">Fecha cierre</div>
          <input formControlName="fecha_cierre" autocomplete="off" required
            class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
            type="date" />
        </div>
        <div class=" estilo-dark dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
          <button (click)="saveConvenio()"
            class="flex items-center mt-6 p-2 bg-gray-50 text-xs uppercase dark:bg-transparent rounded text-gray-500 dark:text-gray-50 font-semibold border-2 border-gray-300 hover:border-blue-600">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
            </svg>
            <span class="ml-2">
              Guardar
            </span>
          </button>
        </div>
      </div>
    </div>
  </form>

  <!--DATA TABLE -->
  <div *ngIf="dataConvenio != null;else cargandoData">
    <ngx-datatable class="material bord" [limit]="10" [rows]="rowsT" rowHeight="auto" [reorderable]="reorderable"
      [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">

      <!-- Nombre -->
      <ngx-datatable-column name="Transportista" [width]="20" class="bord">
        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
          <p>{{ row.scct_transportista.transportista }}</p>
          saldo: ${{ row.saldo }}
        </ng-template>
      </ngx-datatable-column>
      <!-- Apellido Paterno -->
      <ngx-datatable-column name="Fecha inicio" prop="fecha_inicio" [width]="20">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
          {{ value | date: 'dd/MM/yyyy' }}
        </ng-template>
      </ngx-datatable-column>
      <!-- Rol -->
      <ngx-datatable-column name="Fecha cierrre" prop="fecha_cierre" [width]="20">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
          {{ value | date: 'dd/MM/yyyy' }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Estatus" prop="estatus" [width]="20">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

          <svg style="height: 30px;" *ngIf="value == 1;else elsesvg" viewBox="0 0 10 10" fill="green"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="5" cy="5" r="2" />
          </svg>
          <ng-template #elsesvg>
            <svg style="height: 30px;" viewBox="0 0 10 10" fill="tomato" xmlns="http://www.w3.org/2000/svg">
              <circle cx="5" cy="5" r="2" />
            </svg>
          </ng-template>
        </ng-template>
      </ngx-datatable-column>
      <!-- Editar -->
      <ngx-datatable-column name="Acciones" prop="id">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
          <div class="mt-5 flex lg:ml-4 lg:mt-0">
            <span class="hidden sm:block">
              <button (click)="openConvenioModal(row)" type="button"
                class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                <svg class="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor"
                  aria-hidden="true">
                  <path
                    d="M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z" />
                </svg>
                Editar
              </button>
            </span>

            <span class="ml-3 hidden sm:block">
              <button type="button" (click)="updateDepositoModal = true; formSaveDeposito.controls['id_scct_convenio'].setValue(row.id)"
                class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                <svg  class="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor"
                  aria-hidden="true">
                  <path
                    d="M12.232 4.232a2.5 2.5 0 013.536 3.536l-1.225 1.224a.75.75 0 001.061 1.06l1.224-1.224a4 4 0 00-5.656-5.656l-3 3a4 4 0 00.225 5.865.75.75 0 00.977-1.138 2.5 2.5 0 01-.142-3.667l3-3z" />
                  <path
                    d="M11.603 7.963a.75.75 0 00-.977 1.138 2.5 2.5 0 01.142 3.667l-3 3a2.5 2.5 0 01-3.536-3.536l1.225-1.224a.75.75 0 00-1.061-1.06l-1.224 1.224a4 4 0 105.656 5.656l3-3a4 4 0 00-.225-5.865z" />
                </svg>
                Deposito
              </button>
            </span>

          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <ng-template #cargandoData>
    Cargando Información
  </ng-template>
</div>


<div *ngIf="updateConvenioModal"
  class="modal-component-container fixed inset-0 overflow-y-auto dark:text-gray-100 dark:bg-transparent ">
  <div
    class=" dark:bg-gray-900 modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75">

    </div>

    <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:h-screen">&nbsp;</div>

    <div
      class=" modal-container  inline-block align-bottom bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">
      <div class="modal-wrapper dark:bg-gray-900  px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

        <div class=" modal-wrapper-flex  sm:flex sm:items-start">

          <div class=" modal-content flex mt-3 w-full sm:mt-0 sm:ml-0 sm:text-left space-y-3">

            <div class=" dark:text-gray-100 dark:bg-transparent">
              <form [formGroup]="formUpdateConvenio" class="row">
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> Fecha inicio </label>
                  <input formControlName="ufecha_inicio"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="date"  />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> Fecha cierre </label>
                  <input formControlName="ufecha_cierre" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="date" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3" hidden>
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> id </label>
                  <input formControlName="id_scct_convenio" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="number" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> Estatus </label>
                  <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700"
                  formControlName="uestatus">
                  <option value="" selected disabled>Seleccionar transportista</option>
                  <option value="1" >Activo</option>
                  <option value="2" >Iniactivo</option>

                </select>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 flex flex-col">
        <div class="flex justify-end">
          <button (click)="updateConvenioModal = false"
            class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Cerrar
          </button>
          <button (click)="updateConvenio()"
            class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Editar
          </button>
        </div>

      </div>

    </div>
  </div>
</div>

<div *ngIf="updateDepositoModal"
  class="modal-component-container fixed inset-0 overflow-y-auto dark:text-gray-100 dark:bg-transparent ">
  <div
    class=" dark:bg-gray-900 modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75">

    </div>

    <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:h-screen">&nbsp;</div>

    <div
      class=" modal-container  inline-block align-bottom bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">
      <div class="modal-wrapper dark:bg-gray-900  px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

        <div class=" modal-wrapper-flex  sm:flex sm:items-start">

          <div class=" modal-content flex mt-3 w-full sm:mt-0 sm:ml-0 sm:text-left space-y-3">

            <div class=" dark:text-gray-100 dark:bg-transparent">
              <form [formGroup]="formSaveDeposito" class="row">
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> Deposito </label>
                  <input formControlName="monto" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="number" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> Clave de Rastreo </label>
                  <input formControlName="clave_rastreo" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="text" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> Fecha deposito </label>
                  <input formControlName="fecha_deposito" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="date" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3" hidden>
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> id </label>
                  <input formControlName="id_scct_convenio" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="number" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 flex flex-col">
        <div class="flex justify-end">
          <button (click)="updateDepositoModal = false"
            class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Cerrar
          </button>
          <button (click)="saveDeposito()"
            class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Guardar Deposito
          </button>
        </div>

      </div>

    </div>
  </div>
</div>

<div *ngIf="saveTransportistaModal"
  class="modal-component-container fixed inset-0 overflow-y-auto dark:text-gray-100 dark:bg-transparent ">
  <div
    class=" dark:bg-gray-900 modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75">

    </div>

    <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:h-screen">&nbsp;</div>

    <div
      class=" modal-container  inline-block align-bottom bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">
      <div class="modal-wrapper dark:bg-gray-900  px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

        <div class=" modal-wrapper-flex  sm:flex sm:items-start">

          <div class=" modal-content flex mt-3 w-full sm:mt-0 sm:ml-0 sm:text-left space-y-3">

            <div class=" dark:text-gray-100 dark:bg-transparent">
              <form [formGroup]="formSaveTransportista" class="row">
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full  "> TRANSPORTISTA *</label>
                  <input formControlName="transportista" autocomplete="off" required
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="text" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full "> CORREO *</label>
                  <input formControlName="correo" autocomplete="off" required
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="text" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> RFC </label>
                  <input formControlName="rfc" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="text" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> Razon social </label>
                  <input formControlName="razon_social" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="text" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> domicilio </label>
                  <input formControlName="domicilio" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="text" />
                </div>
                <div class=" dark:text-gray-100 dark:bg-transparent md:w-full w-1/3">
                  <label class="w-full estilo-dark dark:text-gray-100 dark:bg-transparent"> Código postal </label>
                  <input formControlName="codigo_postal" autocomplete="off"
                    class="border rounded border-gray-300 placeholder-gray-500 px-3 py-2 block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-blue-400 focus:outline-none focus:ring-blue-500 focus:z-10 focus:shadow-outline-blue dark:text-gray-300 dark:focus:shadow-outline-gray h-12 form-input"
                    type="number" />
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 flex flex-col">
        <div class="flex justify-end">
          <button (click)="saveTransportistaModal = false"
            class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Cerrar
          </button>
          <button (click)="saveTransportista()"
            class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Guardar Transportista
          </button>
        </div>

      </div>

    </div>
  </div>
</div>
